import React, { createContext, useContext, useState, useEffect } from "react";

const PublicKeyContext = createContext();

export const PublicKeyProvider = ({ children }) => {
  const [publicKey, setPublicKey] = useState("");

  useEffect(() => {
    const fetchPublicKey = async () => {
      try {
        const response = await fetch("/public_key.pem");
        if (!response.ok) {
          throw new Error(`Failed to fetch public key: ${response.status} ${response.statusText}`);
        }
        const key = await response.text();
        if (!key || key.trim() === "") {
          throw new Error("Public key file is empty");
        }
        console.log("Public key loaded successfully");
        setPublicKey(key);
      } catch (error) {
        console.error("Error loading public key:", error);
        console.error("Make sure public_key.pem exists in the public folder");
      }
    };

    fetchPublicKey();
  }, []);

  return (
    <PublicKeyContext.Provider value={publicKey}>
      {children}
    </PublicKeyContext.Provider>
  );
};

export const usePublicKey = () => {
  return useContext(PublicKeyContext);
};

